import LoaderSuspense from './_loader-suspense.js'
import FlexPane from './_flex-pane.js'
import Text from './_text.js'
import GridPane from './_grid-pane.js'
import Button from './_button.js'
import CountryIcon from './_country-icon.js'
import Image from './_image.js'
import SportGroupsListSkeleton from './_sport-groups-list-skeleton.js'
import ImageButton from './_image-button.js'

export default {
  name: 'SportGroupsListView',
  values: {
    skeletonLoader: {
      configSet: LoaderSuspense,
      configValues: {},
    },
    enableSorting: false,
    container: {
      configSet: FlexPane,
      configValues: {
        style: {
          padding: '0',
          _mobile_padding: '0 8px',
          flexDirection: 'column',
        },
      },
    },
    headerText: {
      configSet: Text,
      configValues: {},
    },
    headerContainer: {
      configSet: FlexPane,
      configValues: {
        style: {
          height: '40px',
          alignItems: 'center',
          padding: '0 8px',
        },
      },
    },
    mainContainer: {
      configSet: FlexPane,
      configValues: {
        style: {
          flexDirection: 'column',
        },
        itemSpacing: '8px',
      },
    },
    listContainer: {
      configSet: FlexPane,
      configValues: {
        style: {
          padding: '0 8px',
          flexDirection: 'column',
        },
      },
    },
    sportGroupsGridColumns: 2,
    _mobile_sportGroupsGridColumns: 1,
    sportGroupsGrid: {
      configSet: GridPane,
      configValues: {
        defaultColumnSize: '1fr',
        style: {
          gap: '0 16px',
        },
      },
    },
    sportGroupButton: {
      configSet: Button,
      configValues: {
        style: {
          base: {
            alignItems: 'center',
          },
        },
      },
    },
    locationContainer: {
      configSet: FlexPane,
      configValues: {
        style: {
          flexGrow: 0,
          alignItems: 'center',
        },
      },
    },
    countryIcon: {
      configSet: CountryIcon,
      configValues: {
        container: {
          style: {
            padding: '0 8px 0 0',
          },
        },
      },
    },
    sportGroupName: {
      configSet: Text,
      configValues: {
        truncate: true,
      },
    },
    locationName: {
      configSet: Text,
      configValues: {
        truncate: true,
      },
    },
    chevronIcon: {
      configSet: Image,
      configValues: {
        src: 'chevron-right',
        style: {
          minWidth: '8px',
          minHeight: '8px',
        },
      },
    },
    sportGroupsListSkeleton: {
      configSet: SportGroupsListSkeleton,
      configValues: {},
    },
    defaultSortingMethod: undefined,
    minimumClassesToEnableSorting: 5,
    sortingButtonContainer: {
      configSet: FlexPane,
      configValues: {
        style: {
          flexGrow: 0,
        },
      },
    },
    sortEventsToggleButton: {
      configSet: ImageButton,
      configValues: {
        button: undefined,
        innerContainer: {
          itemSpacing: '8px',
          style: {
            flexDirection: 'row',
            justifyContent: 'space-between',
          },
        },
        buttonIcon: {
          src: 'sort',
          style: {
            minWidth: '16px',
            minHeight: '16px',
          },
        },
      },
    },
  },
  meta: {
    extendable: false,
  },
}
